import React from 'react';

import { Button, Modal, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { RetrieveParticipationSchema } from '@app/models/users';

import { Poas } from '../../../Poas';

interface IProps {
  participation?: RetrieveParticipationSchema;
  onClose: () => void;
}

export const PoasModal: React.FC<IProps> = ({ participation, onClose }) => {
  const spaceT = useTranslation(NSKeys.spaceSettings);
  const commonT = useTranslation(NSKeys.common);

  return (
    <Modal
      width="75%"
      open={!!participation}
      title={spaceT.t('poa.title')}
      onCancel={onClose}
      destroyOnHidden
      footer={[
        <Button key="close" onClick={onClose}>
          {commonT.t('buttonClose')}
        </Button>,
      ]}
    >
      {participation && (
        <>
          <Typography.Paragraph type="secondary">{participation.legal_entity.name}</Typography.Paragraph>
          <Poas target={{ kind: 'coalition', uid: participation.uid }} />
        </>
      )}
    </Modal>
  );
};
